export default "__VITE_ASSET__Da7C8tHf__"